// @ts-nocheck
/* eslint-disable */
import { getItem } from "~/es6/localstorage";
import Dashboard from "~/mymaps2/dashboard";
import Reviews from "~/mymaps2/reviews";
import { initSentry } from "~/sentry";
import ActiveRequest from "~/activerequest";
import LoadingPagePromo from  "~/landing-page-promo";
import LanguageControl from "~/languagecontrol2";
import UserwebConfig from "~/userwebconfig";
import MobilePromo from "~/mobilepromo";
import { retargetingHit } from "~/util/sklik";
import { CONFIG, setUserwebConfigData, removeUserwebConfigData } from "~/config";
import Activities from "~/activities";
import CursorManager from '~/es6/cursor';
import Pois from "~/pois";
import { Login } from "~/login";
import ReportDefect from "~/report/reportDefect";
import GPXContent from '~/gpx/content';
import { iframeAnalyticsLog } from "~/util/analyticsAction";
import DistanceMeterContent from "~/distancemeter-content";
import UserMarksContent from "~/usermarks-content";
import { default as SharePositionContent2 } from "~/share-position2/content";
import SharePositionContent from "~/share-position/content";
import SharePositionWhereami from "~/share-position2/whereami";
import Scene from "~/scene";
import Legend from "~/legend";
import PhotoGallery from "~/photo/gallery";
import PhotoDetail from "~/photo/detail";
import DIMCurator from "~/dimcurator";
import dragNdrop from "~/dragNdrop";
import StateArea from "~/state-area";
import { _ } from "~/i18n";
import AndroidAppPromotion from "~/lib/androidAppPromotion";
import Detail from "~/detail";
import { Geolocation } from "~/geolocation";
import Canonical from "~/canonical";
import LayerManager from "~/layermanager";
import { setLocationDebug, locationDebugLog, locationDebugLocation } from "~/location-debug";
import { editorialLoad } from "~/editorial/load";
import { showBadParamNotificationMessage } from "~/util/badParam";
import { initPOIIcons } from "~/util/providers/poiagg";
import { store } from "~/state/store";
import { setCoordinates, setEgg } from "~/state/map/state";
import mapControls from "~/scene/control/mapcontrols";
import ErrorLog from "~/es6/error-log";
import AllIconsContent from "~/all-icons-content";
import NotificationList from "~/notificationlist";
import { startCookieRefresher } from "~/util/cookieRefresher";
import { initReportRefresh } from "~/util/providers/report-refresh";
import Settings from "~/settings";
import PremiumStatus from "~/profile/premium-status";
import { node } from "~/util/dom";
import HoorayDialog from "~/profile/hoorayDialog";
import "~/util/userNotification";
import "~/util/favicon";
import "~/util/geo";
import * as Sentry from "@sentry/browser";
import AlwaysOnMap from "~/scene/common/always-on-map";
import WasmController from "~/wasm/controller";
import { setItem, removeItem as removeCookie, getItem as getCookie } from "./util/cookies";

window.Mapy = {
	active: [], /* aktivni content(y) */
	CDN: {
		setSize: function(url, size, dynamicHeight, nocrop) {
			url = url || "";
			url = url.replace("{width}", size.width);
			url = nocrop ? url.replace("{height},3", "{height},1") : url;
			url = url.replace("{height}", dynamicHeight ? "" : size.height);

			return url;
		},
		SIZE_40_40: { width: 40, height: 40 },
		SIZE_56_56: { width: 56, height: 56 }, // rozmer pro atlas
		SIZE_60_60: { width: 60, height: 60 },
		SIZE_80_52: { width: 80, height: 52 },
		SIZE_80_65: { width: 80, height: 65 },
		SIZE_80_80: { width: 80, height: 80 },
		SIZE_160_104: { width: 160, height: 104 },
		SIZE_112_112: { width: 112, height: 112 }, // rozmer pro atlas
		SIZE_160_130: { width: 160, height: 130 },
		SIZE_160_160: { width: 160, height: 160 },
		SIZE_176_100: { width: 176, height: 100 },
		SIZE_368_113: { width: 368, height: 113 },
		SIZE_400_225: { width: 400, height: 225 },
		SIZE_200_200: { width: 200, height: 200 },
		SIZE_300_300: { width: 300, height: 300 },
		SIZE_400_400: { width: 400, height: 400 },
		SIZE_500_500: { width: 500, height: 500 },
		SIZE_600_600: { width: 600, height: 600 },
		SIZE_667_500: { width: 667, height: 500 }
	},
};

Mapy.init = async function() {
	console.warn("%cChceš se podílet na programování Mapy.com? Mrkni sem: https://kariera.seznam.cz", "font-size: 14px; font-weight: bold;");
	// smap
	SMap.CONFIG.route = "/route";
	SMap.Layer.Tile.DEFAULT_OPTIONS.prefetch = [0, 0];

	Mapy.CUS = CONFIG.UserwebSetting;

	// osetreni pro nastaveni klikatka a def. stavu
	if (!Mapy.CUS) {
		Mapy.CUS = { userweb: {} };
	}
	else if (!("userweb" in Mapy.CUS)) {
		Mapy.CUS.userweb = {};
	}

	["stable", "testing"].indexOf(CONFIG.environment) > -1 && initSentry();

	// ab testy
	if (CONFIG.abTest) {
		let setCookie = false;

		// pridame je do podklice userweb, def. jsou zapnute pro hodnota 1
		CONFIG.abTest.flags.split("|").forEach(flag => {
			if (flag) {
				Mapy.CUS.userweb[flag] = 1;

				if (CONFIG.UserwebSettingCookie.userweb?.[flag]) {
					if (!getCookie(CONFIG.UserwebSettingCookie.userweb[flag])) {
						setItem(CONFIG.UserwebSettingCookie.userweb[flag], "1");
						setCookie = true;
					}
				}
			}
		});

		if (setCookie) {
			setUserwebConfigData(Mapy.CUS);
			window.location.reload();
		}
	}

	if (window.location.search.includes("removeTest=")) {
		removeUserwebConfigData();

		// odebrani starych cookie, ktere jsou nastaveny a uz byt nemaji. At uz z ab testu nebo z klikatka
		if (CONFIG.UserwebSettingCookie && Object.keys(CONFIG.UserwebSettingCookie).length) {
			let removeC = false;

			for (const group in CONFIG.UserwebSettingCookie) {
				if (CONFIG.UserwebSettingCookie[group]) {
					for (const flag in CONFIG.UserwebSettingCookie[group]) {
						if (getCookie(CONFIG.UserwebSettingCookie[group][flag])) {
							removeCookie(CONFIG.UserwebSettingCookie[group][flag]);
							removeC = true;
						}
					}
				}
			}

			if (removeC) {
				window.location = "/";
			}
		}
	}

	if (CONFIG.isScreenshoter) {
		document.body.classList.add("scrst");
	}

	if (Mapy.CUS.userweb?.grpcLocation || Mapy.CUS.userweb?.grpcLocationDebug) {
		// podle klikatka
		setLocationDebug(Mapy.CUS.userweb?.grpcLocationDebug);
		locationDebugLog(`<strong>Cílení polohy</strong>`);
		locationDebugLog(!!CONFIG.user? "Přihlášený uživatel" : "Nepřihlášený uživatel");

		if (CONFIG.location) {
			locationDebugLog(`Z backendu prisla data o poloze uzivatele`);
			locationDebugLocation(CONFIG.location);
		} else {
			locationDebugLog(`Backend nema data o poloze uzivatele`);
		}

		if (CONFIG.locationMeta) {
			locationDebugLog(`<strong>Cookies</strong>`);
			locationDebugLog(`Consent personalized - ${CONFIG.locationMeta.consentPersonalized ? "schvaleny" : "neschvaleny" }`);
			locationDebugLog(`Consent geo precise - ${CONFIG.locationMeta.consentGeoPrecise ? "schvaleny" : "neschvaleny" }`);
			locationDebugLog(`<strong>Log serveru</strong>`);
			CONFIG.locationMeta.log.forEach(log => locationDebugLog(`Server log: ${log}`));
		} else {
			locationDebugLog(`Nemame informace o cookies consentu`);
		}
	}

	this._geoLocationCoords = null;
	this._textOpen = null;
	this._ceskoOpen = false;
	// uz jsem si to jednou zavrel? fallback hodnota je pro jistotu, kdyby nebyla localStorage, tak radeji zadny april, nez porad april
	var closedSto = !!getItem("april2018");
	// tisknu?
	var params = new URLSearchParams(window.location.search.slice(1, window.location.search.length));
	var printSto = params.has("p");
	// cas prave ted
	var now = Date.now();
	this._zaStoOpen = now > 1522533600000 && now < 1522620000000 && !closedSto && !printSto;
	this._mapFirstSet = true;
	this._webglState = null;
	this._sortableIndex = 0;

	// jiny jazyk jak cestina, pomocna css trida na body
	var langName = CONFIG.defaultLang;
	if (langName != "cs") {
		document.body.classList.add("lang-" + langName);
	}
	document.querySelector("html").setAttribute("lang", langName);
	// fix proti roztahovani obrazovky
	document.addEventListener("touchmove", function(e) {
		if (e.scale !== 1 && e.touches.length > 1) { e.preventDefault(); }
	}, navigator.userAgent.indexOf("rv:11.0") != -1 ? false : { passive: false });

	const poiIconsProm = initPOIIcons();
	// kontrola url
	var urlCheck = new Mapy.UrlChecker();
	urlCheck.check();
	/* vyrobit zakladni prvky */
	this._languageControl = new LanguageControl();
	this._logger = new Mapy.Logger();
	this._licenceIntro = new Mapy.LicenceIntro();
	this._licence = new Mapy.Licence();
	this._login = new Login();
	this._print = new Mapy.Print();
	this._masakovac = Scene.createLayerMasakovac();
	// always on map z MM
	this._alwaysOnMap = new AlwaysOnMap();
	this._geolocation = new Geolocation();
	this._pois = null;
	this._webcam = new Mapy.Webcam();
	this._popup = new Mapy.Popup();
	this._reportDefect = new ReportDefect();
	this._search = new Mapy.Search();
	this._loader = new Mapy.Loader();
	this._layout = new Mapy.Layout();
	this._route = new Mapy.Route3();
	this._userProfile = new Mapy.UserProfile();
	this._distanceMeter = new DistanceMeterContent();
	this._gpx = new GPXContent();
	this._imageUploader = new Mapy.ImageUploader();
	this._gps = new Mapy.GPS();
	this._detail = new Detail();
	this._notificationList = new NotificationList();
	this._reviewsList = new Mapy.ReviewsListContent();
	this._settings = new Settings();
	this._premiumStatus = new PremiumStatus();
	this._pathCont = new Mapy.PathContent();
	this._activeRequest = new ActiveRequest();
	this._allIcons = new AllIconsContent();
	this._wasm = new WasmController();

	Mapy.BadPhoto = new BadPhoto();

	this._gallery = new PhotoGallery();
	this._photoDetail = new PhotoDetail();
	this._activities = new Activities();
	this._places = new Places();
	this._dashboard = new Dashboard();
	this._reviews = new Reviews();
	this._profile = new Mapy.ProfileContent();
	this._mymaps = new Mapy.MyMaps2();
	this._pano = new Mapy.Pano();
	this._userMarks = new UserMarksContent();
	if (Mapy.CUS.userweb?.generalSharePosition) {
		this._sharePosition = new SharePositionContent2();
		new SharePositionWhereami();
	} else {
		this._sharePosition = new SharePositionContent();
	}

	// ze scene - init
	this._layout.initWidth();
	Mapy.SEO.setAlternate();

	const loaderDiv = document.createElement("div");

	loaderDiv.classList.add("main-loader");
	loaderDiv.append(node("img", { src: CONFIG.wasmEnabled && location.href.includes("dev.dszn.cz") ? "/img/bunny.gif" : "/img/loader.gif" }));
	CONFIG.wasmEnabled && loaderDiv.append(node("span", { textContent: "Načítám wasm..." }));

	document.getElementById("layout-body").append(loaderDiv);

	const promiseTimeout = new Promise(resolve => {
		setTimeout(resolve, CONFIG.loadMapLoginTimeout || 2000);
	});

	// hlavni load
	const [sceneData, poiIconsData, wasmData] = await Promise.all([
		Scene.init(CONFIG.wasmEnabled),
		poiIconsProm,
		this._wasm.start(CONFIG.wasmEnabled),
		Promise.race([
			this._login.start(),
			promiseTimeout,
		]),
	]);

	loaderDiv.remove();

	// wasm init error
	if (wasmData?.error) {
		await Scene.wasmRerunMap();
	}

	// nahodime hura dialog pro premium zdarma
	new HoorayDialog();

	// nahazujeme az ve chvili, kdy vime bezpecne, ze Scene je ready
	this._layerManager = new LayerManager();
	startCookieRefresher();

	if (!CONFIG.inFrame && window.self !== window.top) {
		if (Date.now() > 1609714800000) { // faze II od 4. 1. 2021
			new Mapy.FrameOverlay();
		}
	}

	this._pois = new Pois(this._layerManager.getTrafficLayer(), this._layerManager.getWinterLayer());

	if (this._geolocation.isSupported()) {
		this._geolocation.initDrop();
	}

	this._stateSwitch = new Mapy.StateSwitch();
	this._stateArea = new StateArea();

	this._dimcurator = new DIMCurator();
	this._tweaksList = new Mapy.TweaksList();
	this._timeboard = new Mapy.Timeboard();
	this._mobilePromo = new (MobilePromo());
	/*this._restaurantPromo = new LoadingPagePromo(PROMO_RESTAURANT);
	this._breweryPromo = new LoadingPagePromo(PROMO_BREWERY);*/
	this._landingPagePromo = new LoadingPagePromo();
	this._legend = new Legend();

	/* vyrobit spravce historie */
	this._history = new Mapy.History();

	/* nacist stav z url */
	this._history.start();

	// pokud prijdu na mapy bez kakychkoliv parametru ulozim
	if (window.location.hash === "" && (window.location.pathname === "/" || window.location.pathname.match(new RegExp(`^\/${CONFIG.defaultLang}\/?$`)))) {
		Mapy.getComponent("history").save(true);
	}

	if (window.location.search.includes("langrdr=") && this._history.state) {
		Mapy.getComponent("history").save(true);
	}

	locationDebugLog("<strong>Nastaveni moji polohy</strong>");
	initReportRefresh();

	/* pokud jsme na telefonu a jdeme na ciste mapy bez parametru, ihned aktivujeme geolokaci */
	if (Mapy.Util.isSmallResolution()) {
		locationDebugLog(`Mobilni zarizeni (male rozliseni) pouzijeme geo lokaci pro moji polohu a viewport`);
		if (window.location.hash == "" && window.location.pathname == "/") {
			this._geolocation.handleEvent();
		}
	} else {
		// nacteni druhe veci
		locationDebugLog(`Desktop (normalni rozliseni)`);

		if (Mapy.CUS.userweb?.grpcLocation || Mapy.CUS.userweb?.grpcLocationDebug) {
			this._geolocation.grpcLoad();
		}
	}

	if (this._textOpen) { Mapy.text(); }
	if (this._zaStoOpen) { Mapy.zasto(); }

	/* dame vedet, ze uz je vse inicializovane */
	this.initialized = true;

	// retargeting pro sklik
	retargetingHit();
	editorialLoad();

	this.createListStyles(50);

	document.body.addEventListener("drop", this);
	document.body.addEventListener("dragover", this);
	document.body.addEventListener("dragstart", this);

	mapControls.init();

	// FIXME: tohle je rychlovec pro povodnovou mapu, pozdeji udelat systematicteji nebo smazat
	if (CONFIG.initialMapset === "humanitarni") {
		Mapy.SEO.set(_("seo.floodTitle"), _("seo.floodDescription"));
		Canonical.set("/humanitarni");
	}

	if (!CONFIG.inFrame && !CONFIG.dontShowAndroidPromo) {
		Mapy.showAndroidAppPromotion();
	}

	this.getComponent("loader").start();
	this.getComponent("loader").end();
}

Mapy.runApp = function() {
	if ((location.hostname.includes("y.cz") || location.hostname.includes("y.com")) && window.geo) {
		geo.conf.showDialogs = true;
	}

	if ("login" in window) {
		const loginCFG = {
			serviceId: "mapy",
			lang: CONFIG.defaultLang,
			onDebugChange: show => {
				Mapy.getComponent("profile").checkDebug(show);
			},
			tld: CONFIG.TLD,
			registerHost: `registrace.seznam.${CONFIG.TLDCZ}`,
			loginHost: `login.szn.${CONFIG.TLDCZ}`,
			accountHost: `ucet.seznam.${CONFIG.TLDCZ}`,
			messStaticHost: `chat.seznam.${CONFIG.TLDCZ}`,

		};

		if (CONFIG.abTest?.flags.includes("login")) {
			loginCFG.test = `${CONFIG.abTest.flags}_${CONFIG.abCountry}`;
		}

		login.cfg(loginCFG);
	}

	const logInitError = error => {
		// logovani do sentry
		Sentry.withScope(scope => {
			scope.setExtras({
				lang: CONFIG.defaultLang,
				isLogged: !!CONFIG.authData,
			});
			Sentry.captureException(error);
		});
	};

	Mapy.init().then(() => {
		if (CONFIG.printMode > 0) {
			Mapy.getComponent("print").prepare(CONFIG.printMode);
		}
	}, error => {
		logInitError(error);
	}).catch(error => {
		logInitError(error);
	});
};

Mapy.handleEvent = function(event) {
	switch (event.type) {
		case "dragover":
		case "dragstart":
			event.preventDefault();
			break;
		case "drop":
			event.preventDefault();
			if (event.dataTransfer && event.dataTransfer.files) {
				dragNdrop.test(event.dataTransfer.files, { photo: true, gpx: true });
			}
			break;
		default:
			//
	}
};

Mapy.getComponent = function(name) {
	switch (name) {
		case "history":				return this._history;
		case "loader":				return this._loader;
		case "layout":				return this._layout;
		case "layerManager":		return this._layerManager;
		case "stateswitch":			return this._stateSwitch;
		case "masakovac":			return this._masakovac;
		case "pois":
			return this._pois || {
				getIcon: () => "",
			};
		case "search":				return this._search;
		case "detail":				return this._detail;
		case "notificationList":	return this._notificationList;
		case "reviewslist":			return this._reviewsList;
		case "settings":			return this._settings;
		case "premiumStatus":		return this._premiumStatus;
		case "distanceMeter":		return this._distanceMeter;
		case "route":				return this._route;
		case "userMarks":			return this._userMarks;
		case "mymaps":				return this._mymaps;
		case "reportDefect":		return this._reportDefect;
		case "login":				return this._login;
		case "imageUploader":		return this._imageUploader;
		case "print":				return this._print;
		case "pano":				return this._pano;
		case "legend":				return this._legend;
		case "geolocation":			return this._geolocation;
		case "gallery":				return this._gallery;
		case "activerequest":		return this._activeRequest;
		case "timeboard":			return this._timeboard;
		case "mobilepromo":			return this._mobilePromo;
		case "webcam":				return this._webcam;
		case "logger":
			return this._logger || {
				log: (action, d, defaultClick) => console.log([action, d, defaultClick]),
			};
		case "statearea":			return this._stateArea;
		case "popup":				return this._popup;
		case "tweaksList":			return this._tweaksList;
		case "gps":					return this._gps;
		case "languageControl":		return this._languageControl;
		case "activities":			return this._activities;
		case "places":				return this._places;
		case "dashboard":			return this._dashboard;
		case "reviews":				return this._reviews;
		case "dimcurator":			return this._dimcurator;
		case "licence":				return this._licence;
		case "profile":				return this._profile;
		case "gpx":					return this._gpx;
		case "photoDetail":			return this._photoDetail;
		case "path":				return this._pathCont;
		case "userProfile":			return this._userProfile;
		case "landingPagePromo":	return this._landingPagePromo;
		case "sharePosition":		return this._sharePosition;
		case "wasm":				return this._wasm;
	}
}

Mapy.debugGlobals = () => ({
	Scene,
	_,
	CONFIG,
	errors: ErrorLog.errors,
	wasm: Mapy._wasm.stats,
});

Mapy.getWasmScreenshot = async (debug: boolean) => {
	if (Mapy._wasm.wasm) {
		try {
			const data = await (debug
				? Mapy._wasm.wasm.getDebugScreenshot()
				: Mapy._wasm.wasm.getScreenshot()
			);

			return data;
		} catch (exc) {
			console.log(exc);
		}
	}

	return null;
};

Mapy.handlePosition = function() {
	return CONFIG.location
		&& (
			window.location.pathname == "/"
			|| window.location.pathname == `/restaurace`
			|| window.location.pathname == `/pivovary`
			|| window.location.pathname == `/publictransport`
		)
		&& !CONFIG.isScreenshoter;
};

Mapy.getPosition = function() {
	var def;

	if (Mapy.handlePosition() && !CONFIG.map) {
		var mcl = CONFIG.location;
		var stateID = this._stateArea.checkCoords(Scene.coordsFromWGS84(mcl.lon, mcl.lat));

		//je z CR nebo je zdroj geoAPI; musi byt v url geocenter=1 napr.
		if (stateID == "cs" || mcl.source == "geoAPI") {
			def = {
				x: mcl.lon,
				y: mcl.lat,
				z: 11
			};

			if (mcl.source == "geoAPI") {
				// geoAPI - kruznice se musi vejit do viewportu <8, 11>
				var newZoom = this.computeZoomFromData({
					x: mcl.lon,
					y: mcl.lat,
					precision: mcl.precision // presnost v m
				});

				def.z = Math.min(Math.max(newZoom, 8), 11);
			}
		}
		//není z ČR (en.mapy.cz) a zdroj je geoIP
		else if (CONFIG.defaultLang !== "cs" && mcl.source === "geoIP") {
			def = {
				x: mcl.lon,
				y: mcl.lat,
				z: Math.min(Math.max(this.computeZoomFromData({
					x: mcl.lon,
					y: mcl.lat,
					precision: mcl.precision
				}), 8), 11)
			};
		}

		if (def) {
			this._geoLocationCoords = def;
		}
	}

	return def;
};

Mapy.getPositionNew = function() {
	const isRootPosition = Mapy.handlePosition();
	const oldAndTrustworthy = location.dateFreshness === "old" && location.isTrustworthy;
	let def;

	locationDebugLog(isRootPosition ? `V url neni pozice` : `V url je cesta ${location.pathname}`);

	if (isRootPosition && (oldAndTrustworthy || !location.isPrecise)) {
		locationDebugLog(`Nastavime viewport podle polohy z backendu - ${oldAndTrustworthy ? "zastarala + duveryhodna poloha" : "nepresna poloha"}`);

		const location = CONFIG.location;
		const newZoom = this.computeZoomFromData({
			x: location.lon,
			y: location.lat,
			// presnost v m
			precision: location.precision,
		});

		// nastavime objekt
		def = {
			x: location.lon,
			y: location.lat,
			z: newZoom,
		};

		this._geoLocationCoords = def;
	} else {
		locationDebugLog(`Informace o poloze zastarala + duveryhodna: ${oldAndTrustworthy}, presna: ${location.isPrecise}`);
		locationDebugLog(`Viewport se nastavi podle defaultni lokace pro dany jazyk`);
	}

	this._mapFirstSet = true;

	return def;
};

Mapy.setState = function(state) {
	let def;

	locationDebugLog(`<strong>Nastaveni viewportu</strong>`);

	if (this._mapFirstSet && !state.z) {
		def = !Mapy.Util.isSmallResolution() && (Mapy.CUS.userweb?.grpcLocation || Mapy.CUS.userweb?.grpcLocationDebug)
			? Mapy.getPositionNew()
			: Mapy.getPosition();
	} else {
		locationDebugLog(`Nelze nastavit viewport - zoom: ${"z" in state}, prvotni nastaveni mapy: ${this._mapFirstSet}`);
	}

	// init pozice
	def = def || {
		x: CONFIG.initialMap.lon,
		y: CONFIG.initialMap.lat,
		z: CONFIG.initialMap.zoom,
	};

	let data = {
		x: "x" in state ? state.x : def.x,
		y: "y" in state ? state.y : def.y,
		z: "z" in state ? state.z : def.z
	};

	if (state.mapset == "ceskojinak") {
		this._ceskoOpen = true;
	}

	if (state.mapset == "ceskoza100") {
		this._zaStoOpen = true;

		var area = Mapy.getComponent("statearea").lastCheck();

		if (!area["cs"] || !area["cs"].find) {
			data = {
				x: CONFIG.initialMap.lon,
				y: CONFIG.initialMap.lat,
				z: CONFIG.initialMap.zoom,
			};
		}
	}

	if (state.mapset == "textova") {
		this._textOpen = true;
	}

	// pouze u mapy; u 3d by se nam zrusil hezky zoom, ktery by prisel jako height/z
	if (Scene.isMapActive()) {
		store.dispatch(setCoordinates({
			longitude: parseFloat(data.x),
			latitude: parseFloat(data.y),
			zoom: CONFIG.wasmEnabled ? parseFloat(data.z) : parseInt(data.z),
			animate: state.z && !this._mapFirstSet,
		}));
	}

	if (state.badParam) {
		showBadParamNotificationMessage();
	}

	this._mapFirstSet = false;
}

Mapy.setPhantomMeta = function(state) {
	var testState = state.toString();
	var printMode = CONFIG.printMode || this._print ? this._print.mode : 0;

	if (printMode > 0 && testState.indexOf("301") != -1) return;

	var search = Mapy.getComponent("search");
	const setCanonical = (search && search.isActive() && search.hasResults()) || CONFIG.inFrame;

	if (setCanonical) {
		Canonical.setByPage();
	}

	var meta = document.querySelector("meta[name='szn:status']");
	if (!meta.content || meta.content == "") {
		meta.content = state;
	}

	if (CONFIG.inFrame) {
		iframeAnalyticsLog({
			type: "load",
			referrer: document.referrer,
		});
	}
};

/**
 * Spuštění mapové sady s aprílem Text (apríl 2017)
 */
Mapy.text = function(close, fromClose) {
	if (close) {
		store.dispatch(setEgg("none"));
	} else {
		store.dispatch(setEgg("textova"));
	}
};

/**
 * spusteni mapove sady s april Ceskem za 100 let (april 2018)
 */
Mapy.zasto = function(close, fromClose) {
	if (close) {
		store.dispatch(setEgg("none"));
	} else {
		store.dispatch(setEgg("ceskoza100"));
	}
};

/**
 * Spocita zoom z data - x, y, a presnost
 * @param  {Object} data
 * @return {int}
 */
Mapy.computeZoomFromData = function(data) {
	data = data || {
		x: 0,
		y: 0,
		precision: 0
	};

	var radLat = data.y * Math.PI / 180;
	var circle = 6371009 * 2 * Math.PI * Math.cos(radLat); /* v metrech */
	var frac = data.precision / circle * 360;
	var c = Scene.coordsFromWGS84(data.x, data.y);
	var c2 = Scene.coordsFromWGS84(data.x + frac, data.y);

	var cz = Scene.computeCenterZoom([c, c2], true);
	return Math.min(cz[1] - 1, 18);
};

/**
 * Webgl state:
 * -1 - lze vytvorit, nejsou ovladace
 * 0 - nelze vytvorit
 * 1 - funguje
 *
 * @return {Number}
 */
Mapy.getWebglState = function() {
	if (this._webglState === null) {
		try {
			var canvas = document.createElement("canvas");
			var ctx = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

			this._webglState = ctx ? 1 : -1;
		}
		catch (e) {
			this._webglState = 0;
		}
	}

	return this._webglState;
};

/* tahle CSS se generuji, aby nemusel existovat soubor, kde by bylo 100 pravidel o jedne vlastnosti */
Mapy.createListStyles = function(count) {
	if (count > this._sortableIndex) {
		var sheet = Mapy.Util.node("style", { type: "text/css" });
		var text = "";

		for (var i = this._sortableIndex; i < count; i++) {
			text += "ul.sortable > li:nth-child(" + (i + 1) + ") { display: block; transform: translate3d(0, " + (i * 100) + "%, 0); } \n";
		}

		sheet.innerHTML += text;

		document.querySelector("head").appendChild(sheet);
		this._sortableIndex = count;
	}
};

Mapy.getGEOLocationCoords = function() {
	return this._geoLocationCoords;
};

Mapy.openConfigDebug = function(pub) {
	if (!this._ucd) {
		this._ucd = new (UserwebConfig(pub));
	}

	this._ucd.activate();
};

Mapy.openLoggerDebug = function() {
	Mapy.getComponent("logger").debug(1);
};

Mapy.openAllIcons = function() {
	this._allIcons.activate().setState({});
};

Mapy.Cursor = new CursorManager();

Mapy.showAndroidAppPromotion = function() {
	new AndroidAppPromotion();
};

window.Mapy = Mapy;
